var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLockPrice = function SvgLockPrice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 17C38.2091 17 40 18.7909 40 21V41C40 43.2091 38.2091 45 36 45H12C9.78 45 8 43.2 8 41V21C8 18.78 9.78 17 12 17H14V13C14 7.47715 18.4772 3 24 3C26.6522 3 29.1957 4.05357 31.0711 5.92893C32.9464 7.8043 34 10.3478 34 13V17H36ZM12 21H36V41H12V21ZM20 31C20 33.2 21.78 35 24 35C26.2091 35 28 33.2091 28 31C28 28.7909 26.2091 27 24 27C21.78 27 20 28.78 20 31ZM18 13C18 9.68629 20.6863 7 24 7C27.3137 7 30 9.68629 30 13V17H18V13Z",
    fill: "#253138"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockPrice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lockPrice.c033de6a.svg";
export { ForwardRef as ReactComponent };